<div class="flex flex-col gap-4">
  @let version = this.analysisStateService.selectedVersion();

  @if (version && version.status === AnalysisVersionStatus.FINISHED) {
    <div class="flex flex-row flex-wrap gap-4">
      @let period = timePeriod();
      <pm-kpi-card
        [label]="'ANALYSIS.TIME_PERIOD' | translate"
        [value]="
          period
            ? this.dateUtilsService.formatMonthYearBasedOnLanguage(
                period.start
              ) +
              ' - ' +
              this.dateUtilsService.formatMonthYearBasedOnLanguage(period.end) +
              (period.coverage
                ? ' ' +
                  ('ANALYSIS.TIME_PERIOD_COVERAGE' | translate: period.coverage)
                : '')
            : '/'
        "
        [tooltip]="
          timePeriodTooltip()?.key
            | translate: { horizon: timePeriodTooltip()?.horizon }
        "
      />
      @if (version.analysisType === AnalysisType.ROLLING) {
        <pm-kpi-card
          [label]="'ANALYSIS.FREEZE_PERIOD' | translate"
          [value]="
            version.minHorizon.toString() +
            ' ' +
            (version.minHorizon > 1
              ? ('RESULT_OVERVIEW.HORIZON.MONTHS' | translate)
              : ('RESULT_OVERVIEW.HORIZON.MONTH' | translate))
          "
          [tooltip]="
            'ANALYSIS.FREEZE_PERIOD_TOOLTIP'
              | translate: { minHorizon: version.minHorizon }
          "
        />
      }
      @let configuration = this.analysisStateService.selectedConfiguration();
      @if (
        version.analysisType === AnalysisType.SINGLE_PERIOD && configuration
      ) {
        @if (configuration.anchorConsensusCycleId !== null) {
          <pm-kpi-card
            [label]="'ANALYSIS.CYCLE' | translate"
            [value]="cycleKpiValue(configuration)"
          />
        }
        @if (configuration.anchorForecastVersionId !== null) {
          <pm-kpi-card
            [label]="'ANALYSIS.FORECAST_VERSION' | translate"
            [value]="
              this.dateUtilsService.formatDateBasedOnLanguage(
                configuration.anchorForecastVersionCreatedAt ?? undefined
              ) || '/'
            "
          />
        }
      }
      @if (calculationLevelKpi(); as calculationLevelKpi) {
        <pm-kpi-card
          [label]="calculationLevelKpi.labelKey | translate"
          [tooltipKey]="calculationLevelKpi.tooltipKey"
        />
      }
    </div>
  }
</div>
